// 親要素にposition: "relative"と指定して使用してください。

import React from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface Props {
    position?: "relative" | "absolute";
    mt?: number;
    progressColor?: string;
}

const SompoLoading = (props: Props) => (
    <Box
        sx={{
            position: props.position || "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: props.mt,
            backgroundColor: "inherit",
            overflow: "hidden",
        }}
    >
        <CircularProgress
            sx={{
                color: props.progressColor || "#c00000",
                p: "10px",
            }}
        />
    </Box>
);

export default SompoLoading;
